import cx from 'classnames';
import { Calendar } from '@components/calendar/Calendar';
import typography from '~styles/typography.scss';
import styles from './DateFilterPopover.scss';

interface DateFilterPopoverProps {
  onDateSelection: (date: Date) => void;
  selectedDate: Date;
  minimumDate?: Date;
}

export const DateFilterPopover = ({
  onDateSelection,
  selectedDate,
  minimumDate,
}: DateFilterPopoverProps) => {
  return (
    <div className={styles.popover} data-testid="date-filter-popover">
      <h1 className={cx(typography.h7, styles.selectDate)}>Select Date</h1>

      <Calendar
        minDate={minimumDate}
        onDateChange={onDateSelection}
        value={selectedDate}
      />
    </div>
  );
};
